export const NOTE_COLORS = ['BLUE', 'RED', 'GREEN', 'YELLOW', 'ORANGE', 'PURPLE'] as const;

export type NoteColor = (typeof NOTE_COLORS)[number];

type BaseNoteMark = {
  start: number;
  end: number;
};

export type BoldNoteMark = BaseNoteMark & {
  type: 'BOLD';
};

export type ColorNoteMark = BaseNoteMark & {
  type: 'COLOR';
  color: NoteColor;
};

export type PrivateNoteMark = BaseNoteMark & {
  type: 'PRIVATE';
};

export type NoteMark = BoldNoteMark | ColorNoteMark | PrivateNoteMark;

export type AnnotatedNotitie = {
  text: string;
  marks: NoteMark[];
};

export type RenderSegment = {
  text: string;
  bold: boolean;
  color?: NoteColor;
  private: boolean;
};

export const EMPTY_ANNOTATED_NOTITIE: AnnotatedNotitie = {
  text: '',
  marks: [],
};
